(() => {
  const roots = new WeakSet();
  const pending = new WeakSet();

  function sync(root) {
    const input = root.querySelector('form.product-form[data-product-form] [data-variant-id-input]');
    const key = input?.value ? `|${input.value}|` : '';
    const loading = root.hasAttribute('data-variant-loading');
    const bundle = root.querySelector('kaching-bundle .kaching-bundles__block');
    const bundleChoices = bundle ? Array.from(bundle.querySelectorAll('select')).filter(select =>
      !select.disabled && select.getClientRects().length > 0 &&
      getComputedStyle(select).display !== 'none' && getComputedStyle(select).visibility !== 'hidden'
    ).map(select => select.value.trim()) : [];
    root.querySelectorAll('[data-zorura-size-summary]').forEach(summary => {
      let found = false;
      const options = Array.from(summary.querySelectorAll('[data-zorura-size-variants]'));
      const bundleSizes = options.filter(option => option.dataset.zoruraSizeOption &&
        bundleChoices.includes(option.dataset.zoruraSizeOption));
      const mixed = bundleSizes.length > 1;
      options.forEach(option => {
        const matches = bundleSizes.length === 1 ? bundleSizes[0] === option :
          key !== '' && option.dataset.zoruraSizeVariants.includes(key);
        const selected = !loading && !mixed && matches;
        if (option.hidden === selected) option.hidden = !selected;
        found ||= selected;
      });
      const line = summary.querySelector('[data-zorura-size-line]');
      const guide = summary.querySelector('[data-zorura-bundle-size-guide]');
      if (line.hidden === found) line.hidden = !found;
      if (guide.hidden === mixed) guide.hidden = !mixed;
    });
  }

  function schedule(root) {
    if (pending.has(root)) return;
    pending.add(root);
    requestAnimationFrame(() => {
      pending.delete(root);
      if (root.isConnected) sync(root);
    });
  }

  function scan() {
    document.querySelectorAll('[data-section-type="product"]').forEach(root => {
      if (!root.querySelector('[data-zorura-size-summary]')) return;
      if (!roots.has(root)) {
        roots.add(root);
        new MutationObserver(() => schedule(root)).observe(root, {
          childList: true, subtree: true, characterData: true,
          attributes: true, attributeFilter: ['data-variant-loading', 'value', 'selected', 'class', 'style', 'hidden', 'disabled', 'aria-checked', 'aria-expanded']
        });
        root.addEventListener('change', () => schedule(root), true);
      }
      schedule(root);
    });
  }

  function start() {
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('product:variant-change', scan);
    document.addEventListener('shopify:section:load', scan);
    window.addEventListener('resize', scan, { passive: true });
    document.addEventListener('click', event => {
      const link = event.target.closest?.('[data-zorura-size-specifications]');
      if (!link) return;
      const root = link.closest('[data-section-type="product"]');
      const accordion = root?.querySelector('.accordion[id="description"]');
      const button = accordion?.querySelector('button.accordion__label');
      if (!button) return;
      event.preventDefault();
      if (button.getAttribute('aria-expanded') !== 'true') button.click();
      accordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
      button.focus({ preventScroll: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
